import { render } from "./TransactionForm.vue?vue&type=template&id=0371ce66"
import script from "./TransactionForm.vue?vue&type=script&lang=js"
export * from "./TransactionForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__